import { render, staticRenderFns } from "./CustomFieldList.vue?vue&type=template&id=1166d140&scoped=true&"
import script from "./CustomFieldList.vue?vue&type=script&lang=js&"
export * from "./CustomFieldList.vue?vue&type=script&lang=js&"
import style0 from "./CustomFieldList.vue?vue&type=style&index=0&id=1166d140&lang=scss&scoped=true&"
import style1 from "./CustomFieldList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1166d140",
  null
  
)

export default component.exports